import React from 'react';
import { TClass } from '../model';
import Checkbox from 'Components/DesignSystem/Checkbox/Checkbox';

type TSubmodelListItemProps = {
    item: TClass;
    isSelected: boolean;
    onToggle: () => void;
}

/**
 * One selectable submodel in the Import Submodel dialog.
 *
 * **This fixes a live bug.** It was a `<div role="button" onClick>` wrapping an
 * `<input type="checkbox" onChange>`, so a click on the box itself fired BOTH — and
 * for a checkbox that is not idempotent: it toggled on, then straight back off.
 * Clicking the box did nothing; only clicking the text worked. Verified at 2 calls
 * against the old markup before this change.
 *
 * DS Checkbox puts the input inside its own `<label>`, so there is one handler and the
 * text is part of the control rather than a sibling with its own click.
 */
const SubmodelListItem = ({ item, isSelected, onToggle }: TSubmodelListItemProps) => (
    <Checkbox
        data-testid="components-submodellistitem-input-1"
        label={item?.name ?? ''}
        checked={isSelected}
        onChange={onToggle}
        className="tw-mb-2"
    />
);

export default SubmodelListItem;
